import components from './components'
import layouts from './layouts'
import composables from './composables'
import * as customPages from './integrations/CustomPage'

export * from './integrations/CustomPage/types'

import { createTLI18n, useI18n } from './utilities/i18n'

export * from './integrations/CustomPage/block-map'
export * from './types'

export {
    createTLI18n,
    useI18n,
}

export default {
    ...components,
    ...customPages,
    ...layouts,
    ...composables,
}
